/**
 * @generated SignedSource<<3c9999f11ee07e47264a20b08321b6e0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditLinkedEvent_note$data = {
  readonly stream: {
    readonly " $fragmentSpreads": FragmentRefs<"LinkEventModal_stream">;
  };
  readonly " $fragmentType": "EditLinkedEvent_note";
};
export type EditLinkedEvent_note$key = {
  readonly " $data"?: EditLinkedEvent_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditLinkedEvent_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditLinkedEvent_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "stream",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "LinkEventModal_stream"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "42ba5870180499091a8ffa2c6f362e7d";

export default node;
